// extracted by mini-css-extract-plugin
module.exports = {"commonTitle":"commonTitle_dU02d","cn":"cn_2QXhY","left":"left_2n6Ob","right":"right_z4n3F","center":"center_PoLIO","en":"en_2gsCT"};